export default __webpack_public_path__ + "assets/images/pricing/fb9f75957a8331d670c86367b289d6ec.png";